export default __webpack_public_path__ + "static/media/sports02.e20bf55f.jpg";